import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ButtonToolbar } from "react-bootstrap";
import {
  FormattedMessage,
  FormattedHTMLMessage,
  FormattedDate,
  intlShape,
} from "react-intl";
import moment from "moment";
import * as types from "../../../../../utils/data/dataActionTypes";
import { EditButton, Render } from "../../../../common";
import { DataTable } from "../../../../common/DataTable";
import BasicBillingPeriodFields from "./BasicBillingPeriodFields";

import {
  ACTIVE_BILLING_PERIODS,
  BILLING_PERIODS,
} from "../../../../../utils/data/models";
import { MANUAL } from "../../enums/billingPeriodTypes";
import * as dataActions from "../../../../../utils/data/dataActions";
import {
  ADMINISTRATOR,
  INFORMATION_AGENT,
  PLAN_ADMINISTRATOR,
  FINTECH,
  DIRECTOR,
} from "../../../../../utils/Roles";
import userHasAccess from "../../../../../utils/userHasAccess";
import { toast } from "react-toastify";
import { TERMINATED } from "../../enums/clientStatusTypes";
import { isSimpleFetchToast } from "../../../../common/RouteValidators/ClientValidationHelper";

class BillingPeriodsDataTable extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.createBillingPeriod = this.createBillingPeriod.bind(this);
    this.generateConfirmationMessage = this.generateConfirmationMessage.bind(
      this
    );
    this.getData = this.getData.bind(this);
    this.getAllBillingPeriods = this.getAllBillingPeriods.bind(this);
    this.updateBillingPeriod = this.updateBillingPeriod.bind(this);
  }

  componentWillMount() {
    this.props.dataActions.clearDataList(BILLING_PERIODS);
    this.getAllBillingPeriods();
  }

  componentWillUnmount() {
    this.props.dataActions.clearDataList(BILLING_PERIODS);
  }

  createBillingPeriod(values) {
    let {
      endDate,
      hasWithdrawalPeriod,
      startWithdrawalDate,
      endWithdrawalDate,
      relatedBillingPeriodId,
      preservePreviousCoverages,
    } = values;
    if (!hasWithdrawalPeriod || startWithdrawalDate == "") {
      startWithdrawalDate = null;
    }
    if (!hasWithdrawalPeriod || endWithdrawalDate == "") {
      endWithdrawalDate = null;
    }
    if (!hasWithdrawalPeriod || !preservePreviousCoverages) {
      relatedBillingPeriodId = null;
    }
    const newValues = {
      ...values,
      endDate: endDate.endOf("day"),
      startWithdrawalDate,
      endWithdrawalDate: !!endWithdrawalDate
        ? endWithdrawalDate.endOf("day")
        : endWithdrawalDate,
      relatedBillingPeriodId,
    };
    return this.props.dataActions
      .createDataItem(BILLING_PERIODS, newValues)
      .then((data) => {
        const isSimpleFetchError = isSimpleFetchToast(data);
        if (data.type === types.CREATE_DATA_ITEM_FAILURE && !isSimpleFetchError) {
          const isSimpleFetchError = isSimpleFetchToast(data);
          if(!isSimpleFetchError) {
            const errorCode = data.payload && data.payload.error && data.payload.error.data && data.payload.error.data.error;
            if(errorCode === "billing_period_delay_criteria_error") {
              toast(<FormattedMessage id="validation.customMessages.serverErrors.billingPeriodDelayCriteriaError"/>, {
                type: toast.TYPE.ERROR,
                autoClose: false,
              });
            } else {
              toast(<FormattedMessage id="validation.customMessages.serverErrors.billingPeriodCreationError"/>, {
                type: toast.TYPE.ERROR,
                autoClose: false,
              });
            }
          }
        } else {
          this.getAllBillingPeriods();
          this.getData(
            this.props.offset,
            this.props.limit,
            this.props.filter,
            this.props.sortBy
          );
        }
      });
  }

  createEmptyBillingPeriodModel(clientId) {
    const localizations = {};
    [...this.props.languages]
      .sort((a, b) => a.languageCode.localeCompare(b.languageCode))
      .map((l) => {
        localizations[l.languageCode] = {
          name: "",
          shortName: "",
          languageCode: l.languageCode,
        };
      });

    return {
      clientId,
      startDate: "",
      endDate: "",
      startWithdrawalDate: "",
      endWithdrawalDate: "",
      localizations,
    };
  }

  updateBillingPeriod(values) {
    let {
      endDate,
      hasWithdrawalPeriod,
      startWithdrawalDate,
      endWithdrawalDate,
      relatedBillingPeriodId,
      preservePreviousCoverages,
      isDelayed,
    } = values;
    if (!hasWithdrawalPeriod || startWithdrawalDate == "") {
      startWithdrawalDate = null;
    }
    if (!hasWithdrawalPeriod || endWithdrawalDate == "") {
      endWithdrawalDate = null;
    }
    if (!hasWithdrawalPeriod || !preservePreviousCoverages) {
      relatedBillingPeriodId = null;
    }
    const newValues = {
      ...values,
      endDate: moment.utc(endDate).endOf("day"),
      startWithdrawalDate,
      isDelayed: !!isDelayed,
      endWithdrawalDate: !!endWithdrawalDate
        ? moment.utc(endWithdrawalDate).endOf("day")
        : endWithdrawalDate,
      relatedBillingPeriodId,
    };

    return this.props.dataActions
      .updateDataItem(BILLING_PERIODS, newValues)
      .then((res) => {
        const isSimpleFetchError = isSimpleFetchToast(res);
        if (res.payload.error && !isSimpleFetchError) {
          if(res.payload.error.data.error === "billing_period_delay_criteria_error") {
            toast(<FormattedMessage id="validation.customMessages.serverErrors.billingPeriodDelayCriteriaError"/>, {
              type: toast.TYPE.ERROR,
              autoClose: false,
            });
          }
          else {
            toast(<FormattedMessage id="validation.clientFieldValidation.unknownAPIError"/>, {
              type: toast.TYPE.ERROR,
              autoClose: false,
            });
          }

        }
        this.getAllBillingPeriods();
        this.getData(
          this.props.offset,
          this.props.limit,
          this.props.filter,
          this.props.sortBy
        );
      });
  }

  getCols() {
    const recurringCanEdit = userHasAccess(
      [ADMINISTRATOR, FINTECH],
      true
    );

    const billingPeriodColumnWidths = {
      locked: 2,
      name:
        this.props.billingPeriodType == "MANUAL" || recurringCanEdit ? 20 : 25,
      startDate:
        this.props.billingPeriodType == "MANUAL" || recurringCanEdit ? 15 : 20,
      endDate:
        this.props.billingPeriodType == "MANUAL" || recurringCanEdit ? 15 : 20,
      withdrawalPeriod:
        this.props.billingPeriodType == "MANUAL" || recurringCanEdit ? 30 : 35,
      actions: 18,
    };

    const billingPeriodColumns = [
      {
        name: <FormattedMessage id="billingPeriods.datatable.columns.name" />,
        key: "localizations.name",
        display: (billingPeriod) => (
          <span>
            {billingPeriod.localizations[this.props.authLanguageCode].name}
          </span>
        ),
        widthPct: billingPeriodColumnWidths.name,
      },
      {
        name: (
          <FormattedMessage id="billingPeriods.datatable.columns.startDate" />
        ),
        key: "startDate",
        display: (billingPeriod) => (
          <FormattedDate
            value={billingPeriod.startDate}
            year="numeric"
            month="long"
            day="2-digit"
            timeZone="UTC"
          />
        ),
        widthPct: billingPeriodColumnWidths.startDate,
      },
      {
        name: (
          <FormattedMessage id="billingPeriods.datatable.columns.endDate" />
        ),
        key: "endDate",
        display: (billingPeriod) => (
          <FormattedDate
            value={billingPeriod.endDate}
            year="numeric"
            month="long"
            day="2-digit"
            timeZone="UTC"
          />
        ),
        widthPct: billingPeriodColumnWidths.endDate,
      },
      {
        name: (
          <FormattedMessage id="billingPeriods.datatable.columns.withdrawalPeriod" />
        ),
        sortKeys: ["startWithdrawalDate", "endWithdrawalDate"],
        display: (billingPeriod) => {
          const { startWithdrawalDate, endWithdrawalDate } = billingPeriod;
          const now = moment().startOf("day");

          return startWithdrawalDate == null || endWithdrawalDate == null ? (
            <FormattedMessage id="billingPeriods.datatable.columns.withdrawalPeriodStatus.notAvailable" />
          ) : (
            <span>
              <FormattedDate
                value={startWithdrawalDate}
                year="numeric"
                month="long"
                day="2-digit"
                timeZone="UTC"
              />
              &nbsp;-&nbsp;
              <FormattedDate
                value={endWithdrawalDate}
                year="numeric"
                month="long"
                day="2-digit"
                timeZone="UTC"
              />
              &nbsp;
              <strong>
                (
                {moment(startWithdrawalDate) <= now &&
                now <= moment(endWithdrawalDate) ? (
                  <FormattedMessage id="billingPeriods.datatable.columns.withdrawalPeriodStatus.open" />
                ) : (
                  <FormattedMessage id="billingPeriods.datatable.columns.withdrawalPeriodStatus.closed" />
                )}
                )
              </strong>
              <a
                className="cell-link"
                target="_blank"
                href={`/desistement/${this.props.clientDesignator}/${
                  billingPeriod.localizations[this.props.authLanguageCode].slug
                }`}
              >
                <span className="icon icon-new-tab" />
              </a>
            </span>
          );
        },
        widthPct: billingPeriodColumnWidths.withdrawalPeriod,
      },
    ];
    if (recurringCanEdit || this.props.billingPeriodType == "MANUAL") {
      billingPeriodColumns.unshift({
        name: "",
        display: (billingPeriod) =>
          billingPeriod.isDateLocked ? <span className="icon-lock" /> : "",
        widthPct: billingPeriodColumnWidths.locked,
      });

      billingPeriodColumns.push({
        name: <FormattedMessage id="datatable.actions" />,
        display: (billingPeriod) => this.generateActionButtons(billingPeriod),
        widthPct: billingPeriodColumnWidths.actions,
      });
    }

    return billingPeriodColumns;
  }

  generateActionButtons(billingPeriod) {
    const { billingPeriodType } = this.props;
    let viewOnly = userHasAccess(
      [INFORMATION_AGENT, PLAN_ADMINISTRATOR],
      true
    );

    if(billingPeriodType === MANUAL.value) {
      viewOnly = !userHasAccess(DIRECTOR);
    }

    if(billingPeriod.client && billingPeriod.client.clientStatusType === TERMINATED.value && !userHasAccess(FINTECH)) {
        viewOnly = true;
    }

    return (
      <ButtonToolbar key={billingPeriod.billingPeriodId}>
        <EditButton
          title={
            <FormattedMessage
              id={`billingPeriods.datatable.actions.${
                viewOnly ? "view" : "edit"
              }`}
            />
          }
          label={
            <FormattedMessage id={viewOnly ? "common.view" : "common.edit"} />
          }
          form={BasicBillingPeriodFields}
          data={{
            ...billingPeriod,
            startDate: moment(billingPeriod.startDate),
            endDate: moment(billingPeriod.endDate),
            startWithdrawalDate: moment(billingPeriod.startWithdrawalDate),
            endWithdrawalDate: moment(billingPeriod.endWithdrawalDate),
            hasWithdrawalPeriod:
              !!billingPeriod.startWithdrawalDate &&
              !!billingPeriod.endWithdrawalDate,
            preservePreviousCoverages: !!billingPeriod.relatedBillingPeriodId,
          }}
          allowSubmission={!viewOnly}
          props={{
            allBillingPeriods: this.props.allBillingPeriods,
            isDelayed: billingPeriod.isDelayed,
            disabled: viewOnly,
            billingPeriodType,
          }}
          editFunction={this.updateBillingPeriod}
          requiresConfirmation={true}
          confirmationValidMessage={this.generateConfirmationMessage}
          confirmationTitle={
            <FormattedMessage id="billingPeriods.datatable.actions.addConfirmationTitle" />
          }
        />
      </ButtonToolbar>
    );
  }

  generateAddButton(clientId, billingPeriodType) {
    const { clientCreditsInvoiceFrequency, clientCreditsInvoiceCount } = this.props;

    return billingPeriodType === MANUAL.value ? (
      <Render for={DIRECTOR}>
        <EditButton
          title={<FormattedMessage id="billingPeriods.datatable.actions.add" />}
          label={<FormattedMessage id="common.add" />}
          add={true}
          form={BasicBillingPeriodFields}
          data={this.createEmptyBillingPeriodModel(clientId)}
          props={{ client: this.props.client, allBillingPeriods: this.props.allBillingPeriods, billingPeriodType: billingPeriodType,
             clientCreditsInvoiceFrequency, clientCreditsInvoiceCount }}
          editFunction={this.createBillingPeriod}
          requiresConfirmation={true}
          confirmationValidMessage={this.generateConfirmationMessage}
          confirmationTitle={
            <FormattedMessage id="billingPeriods.datatable.actions.addConfirmationTitle" />
          }
        />
      </Render>
    ) : null;
  }

  generateConfirmationMessage(values) {
    const { formatDate } = this.context.intl;
    const dateFormat = {
      year: "numeric",
      month: "long",
      day: "2-digit",
      timeZone: "UTC",
    };
    let mapping = {};

    mapping.name = values.localizations[this.props.authLanguageCode].name;
    mapping.startDate = formatDate(values.startDate, dateFormat);
    mapping.endDate = formatDate(values.endDate, dateFormat);
    mapping.isDelayed = !!values.isDelayed;
    mapping.billingPeriodType = this.props.billingPeriodType; // To show/hide isDelayed from the confirmation screen, depending on billing type.
    mapping.isBillable = this.props.isBillable;
    mapping.withdrawalPeriod =
      !values.hasWithdrawalPeriod ||
      !values.startWithdrawalDate ||
      !values.endWithdrawalDate
        ? "NONE"
        : formatDate(values.startWithdrawalDate, dateFormat) +
          " - " +
          formatDate(values.endWithdrawalDate, dateFormat);
    mapping.preserveCoverages =
          !values.hasWithdrawalPeriod || !values.preservePreviousCoverages
            ? "NONE"
            : this.props.allBillingPeriods.find(
                (period) => period.billingPeriodId == values.relatedBillingPeriodId
              ).localizations[this.props.authLanguageCode].name;
    mapping.creditsInvoiceFrequency = values.creditsInvoiceFrequency !== null ? values.creditsInvoiceFrequency.toString(): "";
    mapping.creditsInvoiceCount = values.creditsInvoiceCount !== null ? values.creditsInvoiceCount.toString() : "";
    return (
      <FormattedHTMLMessage
        id="billingPeriods.datatable.actions.addConfirmationMessage"
        values={mapping}
      >
        {(m) => (
          <div
            className="formatted-confirmation-bps"
            dangerouslySetInnerHTML={{ __html: m }}
          />
        )}
      </FormattedHTMLMessage>
    );
  }

  getData(offset, limit, q, sortBy) {
    let filter = [`billingPeriods.clientId==${this.props.clientId}`];
    return this.props.dataActions
      .getDataList(BILLING_PERIODS, offset, limit, q, sortBy, filter)
      .then(() => {
        const now = new Date().toISOString();
        this.props.dataActions.getDataList(
          ACTIVE_BILLING_PERIODS,
          0,
          0,
          "",
          ["startDate:asc"],
          [
            `clientId==${this.props.clientId}`,
            `startDate=lt=${now}`,
            `endDate=gt=${now}`,
          ]
        );
      });
  }

  getAllBillingPeriods() {
    this.props.dataActions.getDataList(
      { ...BILLING_PERIODS, name: "allBillingPeriods" },
      0,
      0,
      "",
      ["startDate:desc"],
      [`clientId==${this.props.clientId}`],
      {},
      {},
      "billingPeriodId,startDate,endDate,localizations"
    );
  }

  render() {
    return (
      <DataTable
        ref="dataTable"
        title={<FormattedMessage id="billingPeriods.title" />}
        getData={this.getData}
        cols={this.getCols()}
        filter={this.props.filter}
        offset={this.props.offset}
        data={this.props.items}
        rowsPerPage={this.props.limit}
        totalRows={this.props.total}
        sortBy={this.props.sortBy}
        addButton={this.generateAddButton(
          this.props.clientId,
          this.props.billingPeriodType
        )}
      />
    );
  }
}

BillingPeriodsDataTable.propTypes = {
  allBillingPeriods: PropTypes.array,
  billingPeriodType: PropTypes.string,
  dataActions: PropTypes.object,
  filter: PropTypes.string,
  items: PropTypes.array,
  limit: PropTypes.number,
  offset: PropTypes.number,
  sortBy: PropTypes.array,
  total: PropTypes.number,
  clientId: PropTypes.number,
  clientDesignator: PropTypes.string,
  statuses: PropTypes.array,
  languages: PropTypes.array.isRequired,
  clientCreditsInvoiceFrequency: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  clientCreditsInvoiceCount: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  isBillable: PropTypes.bool,
  authLanguageCode: PropTypes.string,
  client: PropTypes.object,
};

BillingPeriodsDataTable.contextTypes = {
  intl: intlShape,
};

function mapStateToProps(state) {
  const allBillingPeriods = state.data.allBillingPeriods || {};
  const data = state.data.billingPeriods || {};
  const pagination = data.pagination || {};

  return {
    allBillingPeriods: allBillingPeriods.items || [],
    clientId: state.data.clients.active.clientId,
    clientDesignator: state.data.clients.active.designator,
    clientCreditsInvoiceFrequency: state.data.clients && 
    state.data.clients.active ? state.data.clients.active.creditsInvoiceFrequency: null,
    clientCreditsInvoiceCount: state.data.clients && state.data.clients.active ? state.data.clients.active.creditsInvoiceCount : null,
    billingPeriodType: state.data.clients.active.clientBillingPeriodType,
    authLanguageCode: state.auth.user.languageCode,
    isBillable: state.data.clients.active.isBillable,
    client: state.data.clients.active,
    q: data.q,
    limit: pagination.limit || 100,
    offset: pagination.offset || 0,
    sortBy: data.sortBy || ["startDate:desc"],
    total: pagination.totalCount || 0,
    items: data.items || null,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BillingPeriodsDataTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/billingPeriods/BillingPeriodsDataTable.js